require("./_layout.scss");

require("./grid-system/js/respond.js");
